import React from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

export type GlobalProductsViewProps<TData> = Pick<
  TableWrapperProps<TData>,
  "data" | "columns"
>;

export default function GlobalProductsView<TData>({
  data,
  columns,
}: GlobalProductsViewProps<TData>) {
  return (
    <>
      <SimpleHeader name="Display Products" parentName="Products" />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader>
            <h3 className="mb-0">All Products</h3>
          </CardHeader>
          <CardBody>
            <TableWrapper data={data} columns={columns} />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
